import { Button, Modal, Typography } from 'antd';
import GruposService from 'services/GruposService';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { GRUPO_SETTINGS } from '../GrupoSettings';
import EnviarDadosNavegacao from 'EstruturaAntiga/actions/Navegacao/EnviarDadosNavegacao';

const { Text, Paragraph } = Typography;

function GrupoExclusaoButton({ grupoId }){

    const handleExclusao = async () => {
        await GruposService.ExcluirGrupo(grupoId)
            .then(response => {
                modalSucesso(response);
            })
            .catch(error => {
                modalErro(error.response?.data?.erros[0] ?? ['Erro inesperado ao excluir grupo']);
            })
    };

    const ObterGrupo = async () => {
        let grupo;
        if (!grupoId) {
            modalErro('O Id do grupo não foi informado');
        }

        await GruposService.ObterGrupoPorId(grupoId, false, false, false)
            .then(response => {
                grupo = response;
            })
            .catch(error => {
                modalErro(error.response?.data?.erros[0] ?? 'Erro inesperado ao obter o grupo');
            });

        return grupo;
    }

    const modalConfirmacao =  async () => {
        EnviarDadosNavegacao('grupos/excluir', true);
        
        const grupo = await ObterGrupo();
        if (!grupo) {
            return
        }
        if (grupo.razaoStatus && grupo.razaoStatus == GRUPO_SETTINGS.RAZAO_STATUS.EM_SINCRONIZACAO) {
            modalErro('O grupo já se encontra em sincronização. Aguarde a conclusão da operação para fazer a solicitação.');
            return;
        }
        
        Modal.confirm({
            title: 'Tem certeza que deseja excluir o grupo abaixo?',
            icon: <ExclamationCircleFilled />,
            content: bodyConfirmacao(grupo),
            width: 480,
            okText: 'Confirmar exclusão',
            okType: 'danger',
            cancelText: 'Cancelar',
            centered: true,
            async onOk() {
                await handleExclusao();
            }
        });
    };

    const modalSucesso = (mensagem) => {
        Modal.success({
            title: 'Sucesso!',
            content: mensagem,
            centered: true
        });
    };

    const modalErro = (mensagem) => {
        Modal.error({
          title: 'Erro ao excluir grupo',
          content: mensagem,
          centered: true
        });
    };

    const bodyConfirmacao = (grupo) => {
        return (
            <>
                <p style={{marginBottom: '0'}}>Nome: {grupo.nomeExibicao}</p>
                <p>Email: {grupo.email}</p>

                <div style={{
                    background: '#fff7e6',
                    border: '1px solid #ffd591',
                    borderLeft: '4px solid #fa8c16',
                    borderRadius: '4px',
                    padding: '12px 16px',
                    marginTop: '12px'
                }}>
                    <Paragraph style={{ marginBottom: 8 }}>
                        <Text strong>Atenção:</Text> ao excluir este grupo, você também excluirá todos os conteúdos e serviços vinculados a ele, incluindo:
                    </Paragraph>
                    <ul style={{ marginBottom: 8, paddingLeft: 20 }}>
                        <li>SharePoint e arquivos armazenados</li>
                        <li>Teams, Planner e caixa de correio</li>
                        <li>Conversas e demais recursos associados</li>
                    </ul>
                    <Paragraph style={{ marginBottom: 0 }}>
                        O grupo poderá ser restaurado em até <Text strong>30 dias</Text> mediante solicitação de serviço. Após esse prazo, a exclusão será permanente.
                    </Paragraph>
                </div>
            </>
        )
    };

    return(
        <Button type='primary' onClick={()=> modalConfirmacao()} danger >
            Excluir
        </Button>
    )
}

export default GrupoExclusaoButton;